import { Box } from "@mui/material";
import "./Loader.css";
import { tomarketGreenLogo } from "assets/assets";

const Loader = () => {
  return (
    <div className="loader-container">
      <Box component="img" src={tomarketGreenLogo} alt="toMarket Logo" className="logo-pulse" />
    </div>
  );
};

export default Loader;
